import { useJsonFile } from './useJsonFile'

/// Points/referral snapshot produced by scripts/indexPoints.cjs - a plain static file under
/// public/, served at the site root by Vite, not a live contract read (points aren't stored
/// on-chain at all - see ReferralRegistry.sol's own doc comment for why). Read once per mount via
/// the shared `useJsonFile`; the file only changes when the indexer is re-run and redeployed.
export function usePointsData() {
  const { data, loading } = useJsonFile('/points.json')

  function pointsFor(address) {
    if (!data || !address) return null
    return data.points[address.toLowerCase()] ?? null
  }

  return { data, loading, pointsFor }
}
